import React, { PureComponent, Fragment } from 'react';
import { Row, Col, Divider, Form, Button, Icon } from 'antd';
import PhoneNumberMask from '../../../../../../common/inputs/AuthorizationInputs';

import './forms.css';
import moment from 'moment';

import {
  SubjectId,
  Name,
  LastName,
  Patronymic,
  PhoneCode,
  // PhoneNumber,
  Email,
  RequestId,
  PassengersCount,
  StartPoint,
  ArrivalDate,
  ArrivalTime,
  Comment,
  Customer,
  Inn,
} from './fieldsConfig';

class ReverseForm extends PureComponent {
  render() {
    const { request, form, showDrawer } = this.props;
    const { getFieldDecorator } = form;
    const company = request.profileId ? request.profileId.companyId : null;
    // const dateNow = new Date().getTime();
    // const dateArrival = new Date(moment(request.arrivalDateTime)).getTime();
    // const days = Math.ceil(
    //   Math.abs(dateArrival - dateNow) / (1000 * 3600 * 24)
    // );

    return (
      <div className="requestCardForm">
        <Form>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Номер заявки:</span>
            </Col>
            <Col span={12} className="formCol">
              <RequestId
                val={request.number ? request.number : 'не указана'}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
            <Col span={6} className="formCol">
              <Button
                type="link"
                className="withIcon"
                onClick={() => window.print()}
              >
                Распечатать
                <Icon type="printer" />
              </Button>
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Субъект заказчика:</span>
            </Col>
            <Col span={12} className="formCol">
              <SubjectId
                val={
                  !company
                    ? 'Не указано'
                    : company.subjectId.subjectKey === 'individ'
                    ? company.subjectId.subjectAbbr
                    : company.subjectId.subject
                }
                decorator={getFieldDecorator}
                classes="middle"
                disabled
              />
            </Col>
            <Col span={6} className="formCol">
              <Button
                id="requisitesPhysical"
                onClick={e => showDrawer(e)}
                block
                className="btn"
              >
                Подробнее
              </Button>
            </Col>
          </Row>
          {!company ? null : company.subjectId.subjectKey === 'physical' ? (
            <Fragment>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">Фамилия:</span>
                </Col>
                <Col span={12} className="formCol">
                  <LastName
                    val={company.lastname}
                    decorator={getFieldDecorator}
                    classes="short"
                    disabled
                  />
                </Col>
              </Row>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">Имя:</span>
                </Col>
                <Col span={12} className="formCol">
                  <Name
                    val={company.name}
                    decorator={getFieldDecorator}
                    classes="short"
                    disabled
                  />
                </Col>
              </Row>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">Отчество:</span>
                </Col>
                <Col span={12} className="formCol">
                  <Patronymic
                    val={company.patronymic}
                    decorator={getFieldDecorator}
                    classes="short"
                    disabled
                  />
                </Col>
              </Row>
            </Fragment>
          ) : (
            <Fragment>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">Заказчик:</span>
                </Col>
                <Col span={12} className="formCol">
                  <Customer
                    val={company.nameLegal}
                    decorator={getFieldDecorator}
                    classes="long"
                    disabled
                  />
                </Col>
              </Row>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">ИНН:</span>
                </Col>
                <Col span={12} className="formCol">
                  <Inn
                    val={company.inn}
                    decorator={getFieldDecorator}
                    classes="long"
                    disabled
                  />
                </Col>
              </Row>
            </Fragment>
          )}
          <Divider />
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Номер телефона:</span>
            </Col>
            <Col span={12} className="formCol">
              <Col span={12} className="formCol" style={{ paddingLeft: '0' }}>
                <PhoneCode
                  val={request.profileId ? request.profileId.phoneCode : null}
                  // val={!company ? null : company.phoneCode}
                  decorator={getFieldDecorator}
                  classes="small mr"
                  disabled
                />
                {/*
                <PhoneNumber
                  val={!company ? 'Не указано' : company.phone}
                  decorator={getFieldDecorator}
                  classes="short"
                  mask="(###) ###-##-##"
                  disabled
                />*/}
                <PhoneNumberMask
                  autoComplete="off"
                  className="short"
                  name="phone"
                  mask="(###) ###-##-##"
                  value={
                    request.profileId
                      ? request.profileId.phoneNumber
                      : 'undefined'
                  }
                  // value={company && company.phone ? company.phone : ''}
                  maxLength={15}
                  disabled
                />
              </Col>
            </Col>
          </Row>
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">E-mail:</span>
            </Col>
            <Col span={12} className="formCol">
              <Email
                // val={request.profileId ? request.profileId.email : 'Не указан'}
                val={request.profileId ? request.profileId.email : 'Не указан'}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
          <Divider />
          {+request.passengersCount > 0 && (
            <>
              <Row type="flex" align="middle" className="formRow" gutter={16}>
                <Col span={6} className="formCol right">
                  <span className="label">
                    Максимальное количество пассажиров:
                  </span>
                </Col>
                <Col span={3} className="formCol">
                  <PassengersCount
                    val={
                      request.passengersCount !== null
                        ? request.passengersCount
                        : '0'
                    }
                    decorator={getFieldDecorator}
                    classes="small mr"
                    disabled
                  />
                </Col>
              </Row>
              <Divider />
            </>
          )}
          <Row type="flex" align="middle" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Адрес пункта подачи ТС:</span>
            </Col>
            <Col span={12} className="formCol">
              <StartPoint
                val={
                  request.routes.length ? request.routes[0].route : 'Не указано'
                }
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
            <Col span={6} className="formCol">
              <Button
                id="routeMap"
                block
                className="btn"
                onClick={request.routes.length ? e => showDrawer(e) : null}
              >
                Показать на карте
              </Button>
            </Col>
          </Row>
          <Row
            type="flex"
            align="middle"
            className="formRow withFieldInfo"
            gutter={16}
          >
            <Col span={6} className="formCol right">
              <span className="label">Дата и время подачи ТС:</span>
            </Col>
            <Col span={12} className="formCol">
              <ArrivalDate
                val={
                  request.arrivalDatetime
                    ? moment(request.arrivalDatetime).format('DD.MM.YYYY')
                    : 'Не указано'
                }
                decorator={getFieldDecorator}
                classes="short mr"
                disabled
              />
              <ArrivalTime
                val={
                  request.arrivalDatetime
                    ? moment(request.arrivalDatetime).format('HH:mm')
                    : ''
                }
                decorator={getFieldDecorator}
                classes="medium"
                disabled
              />
              {request.arrivalDatetime ? (
                <span className="fieldInfo">
                  {new moment(request.arrivalDatetime).fromNow()}
                  {request.routes[0] && request.routes[0].duration
                    ? ` (Длительность посадки: ${moment
                        .duration(request.routes[0].duration)
                        .asMinutes()} мин)`
                    : ''}
                </span>
              ) : null}
            </Col>
          </Row>
          <Divider />
          <Row type="flex" className="formRow" gutter={16}>
            <Col span={6} className="formCol right">
              <span className="label">Комментарий:</span>
            </Col>
            <Col span={12} className="formCol">
              <Comment
                val={request.comment}
                decorator={getFieldDecorator}
                classes="long"
                disabled
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default Form.create()(ReverseForm);
